import { useSetAtom } from "jotai";
import { useCallback } from "react";
import { draftReturnAtomFamily } from "../atoms/draft-return.atom";
import { setRebuyItems } from "../lib/draft.lib";
import type { CartItem } from "../types";

export function useSetRebuyItems(orderId: string) {
  const setDraft = useSetAtom(draftReturnAtomFamily(orderId));

  return useCallback(
    (rebuyItems: CartItem[]) => {
      setDraft((draft) => (draft ? setRebuyItems(draft, rebuyItems) : draft));
    },
    [setDraft],
  );
}
